const apiUrl = process.env.REACT_APP_API_URL;

function getBasicAuthHeader() {
  const username = process.env.REACT_APP_API_USERNAME;
  const password = process.env.REACT_APP_API_PASSWORD;
  const encodedCredentials = btoa(`${username}:${password}`);
  return `Basic ${encodedCredentials}`;
}

/** Current subscription snapshot + past invoices for the purchase-history page. */
export async function fetchBillingOverview(userId) {
  const res = await fetch(`${apiUrl}/api/stripe/billing/${userId}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Accept: '*/*',
      Authorization: getBasicAuthHeader(),
    },
  });
  if (!res.ok) {
    throw new Error(`Billing overview failed: ${res.status}`);
  }
  return res.json();
}

/** Schedule the subscription to cancel at period end. Returns the refreshed overview. */
export async function cancelSubscriptionAtPeriodEnd(userId) {
  const res = await fetch(`${apiUrl}/api/stripe/cancel-subscription`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: '*/*',
      Authorization: getBasicAuthHeader(),
    },
    body: JSON.stringify({ userId }),
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.error || `Cancel failed: ${res.status}`);
  }
  return res.json();
}
